<template>
  <Spin :spinning="config.loading" tip="尝试连接中">
    <div class="gpy-manage">
      <div class="gpy-manage__pri">
        <img v-if="config.priImageData" :src="config.priImageData" />
        <Empty v-else />
      </div>
      <div class="action">
        <div class="action__box">
          <GpyStatus :status="!config.error" @reload="initSignal" />
          <!-- 保存到本地 -->
          <div class="action__item save">
            <div class="save__name">保存到本地</div>
            <Switch v-model:checked="config.saveToLocal" />
          </div>
          <!-- 图片尺寸 -->
          <div class="action__item">
            <div class="action__name">图片尺寸</div>
            <Select v-model:value="config.scanSize" placeholder="请选择图片尺寸" class="action__select">
              <Select.Option v-for="(item, key) in SCAN_SIZE_MAP" :key="key" :label="item">
                {{ item }}
              </Select.Option>
            </Select>
          </div>
          <!-- 图片质量 -->
          <div class="action__item">
            <div class="action__name">图片质量</div>
            <Select
              v-model:value="config.priResolution"
              placeholder="请选择图片质量"
              class="action__select"
              :disabled="!config.priResolutionList.length"
            >
              <Select.Option v-for="item in config.priResolutionList" :key="item.value" :label="item.label">
                {{ item.label }}
              </Select.Option>
            </Select>
          </div>
          <div class="handle">
            <div class="handle__item" @click="rotateLeft">
              <RotateLeftOutlined />
              <div>左转</div>
            </div>
            <div class="handle__item" @click="rotateRight">
              <RotateRightOutlined />
              <div>右转</div>
            </div>
            <div class="handle__item" :class="{ 'handle__item--active': config.delBgColor }" @click="delBgColor">
              <BgColorsOutlined />
              <div>底色</div>
            </div>
            <div class="handle__item" :class="{ 'handle__item--active': config.isDeskew }" @click="setDeskew">
              <RadiusSettingOutlined />
              <div>纠偏</div>
            </div>
          </div>
        </div>
        <div class="action__bottom">
          <Button size="large" type="primary" @click="handleCapture">拍照</Button>
          <Button size="large" type="primary" ghost :disabled="isUploadDisabled" @click="handleUpload"> 上传文件</Button>
        </div>
      </div>
    </div>
    <CaptureList v-model:list="config.priPhotoData" />
  </Spin>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'
import { useMagicKeys } from '@vueuse/core'
import { Button, Empty, Select, Spin, Switch } from 'ant-design-vue'
import useGpy from './useGpy'
import GpyStatus from './GpyStatus.tsx'
import CaptureList from './CaptureList.tsx'
import { SCAN_SIZE_MAP } from './helper'
import { BgColorsOutlined, RadiusSettingOutlined, RotateLeftOutlined, RotateRightOutlined } from '@ant-design/icons-vue'
const { initSignal, rotateLeft, rotateRight, delBgColor, setDeskew, handleCapture, handleUpload, config } = useGpy()
const isUploadDisabled = computed(() => config.priPhotoData.every(item => item.status === 'uploaded'))
const keys = useMagicKeys()
const space = keys['space']
watch(space, v => {
  if (v) {
    handleCapture()
  }
})
</script>
<style lang="less" scoped>
.gpy-manage {
  display: flex;

  &__pri {
    flex: 0 0 64%;
    max-width: 64%;
    padding-bottom: 49%;
    position: relative;

    & > * {
      width: 100%;
      height: 100%;
      position: absolute;
      user-select: none;
    }

    img {
      object-fit: cover;
    }

    .ant-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}

.action {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 20px;
  position: relative;

  &__item {
    padding-bottom: 20px;
  }

  &__name {
    padding-bottom: 10px;
    font-weight: 900;
  }

  &__select {
    width: 100%;
  }

  &__bottom {
    display: flex;

    & > * {
      flex: 1;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}

.handle {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;

  &__item {
    display: flex;
    flex: 0 0 calc(50% - 10px);
    align-items: center;
    justify-content: center;
    margin: 0 5px 10px;
    padding: 10px;
    border-radius: @border-radius-base;
    color: @text-color;
    background: @background-color-base;
    cursor: pointer;

    &:hover {
      background: @bg-fade-2;
    }

    &--active {
      color: @primary-color;
    }

    .anticon {
      font-size: 20px;
    }

    div {
      padding-left: 10px;
      font-size: 16px;
    }
  }
}

.save {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 900;
}
</style>
